// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1534":"e568a04d","1844":"14d39284","2228":"e568a04d","6254":"347cf2a8","6455":"ae2d3293","7957":"3e98bf94","8688":"7fe95281","9915":"fcfb4dfc","9962":"9c125b46"}[chunkId] + ".chunk.css";
};